<template>
	<span
		aria-hidden="true"
		:class="clsx(
			className,
			'w-[2.25rem] select-none text-center text-sm/6 font-semibold text-zinc-950 dark:text-white')">
		&hellip;
	</span>
</template>

<script lang="ts">
	export default { name: 'VPaginationGap' } // name the component
</script>

<script setup lang="ts">
	import { 
		clsx
	} from 'clsx'

	const props = defineProps({
		className: {
			type: String,
			default: ''
		}
	})
</script>